module.exports = __webpack_public_path__ + "img/second.00dafa02.jpg";